import React, { useEffect, useState } from "react";
import SlotVIew from "./SlotVIew";
import { useNavigate, useParams } from "react-router";

function ApprovalSlotView() {
  const { id } = useParams();
  const [slot_id, setSlot_id] = useState(id)
  const navigate = useNavigate();

  useEffect(() => {
    if(!slot_id){
      navigate("/home/slotbooking")
    }
  }, [slot_id])
  return (
    <div>
      {slot_id ? <SlotVIew slot_id={slot_id} setSlot_id={setSlot_id} /> : null}
    </div>
  );
}

export default ApprovalSlotView;
